module.exports = __webpack_public_path__ + "static/media/ex.86d5baf3.svg";